import * as React from 'react';
import { Fragment } from 'react';
import { makeStyles } from '@material-ui/core/styles';
import { required, minLength, maxLength, minValue, maxValue, number, regex, email, choices } from 'react-admin';
import {
  useRedirect,
  List,
  Datagrid,
  Filter,
  Edit,
  Create,

  Toolbar,
  TopToolbar,
  DeleteWithConfirmButton,
  BulkDeleteWithConfirmButton,
  Show,
  SimpleShowLayout,

  ReferenceField,
  TextField,
  ImageField,
  BooleanField,

  SimpleForm,
  ReferenceInput,
  SelectInput,
  TextInput,
  NumberInput,
  BooleanInput,
  NullableBooleanInput,

  Button,
  EditButton,
  ShowButton,
  SaveButton,
} from 'react-admin';
import { UpLoadFile } from './custom/UpLoadFile';
import { ArrowBack } from '@material-ui/icons';
import { CustomRichTextInput } from './custom/CustomRichTextInput';
//import ResetOrderNum from './Wiki_ResetOrderNum';

{/* 
  import { WikiList, WikiCreate, WikiEdit, WikiShow } from './components/Wiki';

  <Resource name="CMSWiki" list={WikiList} create={WikiCreate} edit={WikiEdit} show={WikiShow} />
  <Resource name="CMSWiki" list={ListGuesser} create={EditGuesser} edit={EditGuesser} edit={ShowGuesser} /> 
*/}

const useStyles = makeStyles({
  imageField: {
    '& img': { width: 60 }
  },
});

const useTxtData = {
  page: {
    tableName: 'Wiki',
  },
  table: {
    id: '编号',
    Title: '小程序标题',
    OrderTip: '下单提示语',
    SearchTip: '搜索提示语',
    SearchHotKeys: '搜索提示关键词',
    KeFuTel: '客服电话',
    AdsPics: '广告图',
    AdsUrls: '广告图链接',
  }
};

//分页列表页面
export const WikiList = (props) => {
  //筛选器模块
  const Filters = (props) => {
    return (
      <Filter {...props}>
        {/* <TextInput label="ID" source="id" alwaysOn resettable /> */}
        {/* <TextInput label="XX" source="name" alwaysOn resettable /> */}
      </Filter>
    );
  };
  //批量操作模块
  const AssetBulkActionButtons = (props) => {
    return (
      <Fragment>
        {/* <ResetOrderNum label="重置排序" {...props} /> */}
        {/* <BulkDeleteWithConfirmButton {...props} confirmTitle="删除确认" confirmContent="确认要删除所选记录吗？" /> */}
      </Fragment>
    );
  };
  //行右侧功能按钮
  const RowAction = (props) => {
    return (
      <div style={{ textAlign: 'right' }}>
        <EditButton {...props} /><br />
        {/* <ShowButton {...props} /><br /> */}
        {/* <DeleteWithConfirmButton {...props} confirmTitle="删除确认" confirmContent="确认要删除该记录吗？" /> */}
      </div>
    );
  }

  const classes = useStyles();
  return (
    <List {...props} title={useTxtData.page.tableName + '列表'} sort={{ field: 'id', order: 'DESC' }} filters={<Filters />} bulkActionButtons={false} >
      <Datagrid>
        {/* <TextField source="id" /> */}
        {/* <TextField label="名称" source="Name" /> */}
        {/* <TextField label="排序" source="OrderNum" />  */}
        {/* <TextField label={useTxtData.table.WikiID} source="id" /> */}
        <TextField label={useTxtData.table.Title} source="Title" />
        {/* <TextField label={useTxtData.table.OrderTip} source="OrderTip" /> */}
        <TextField label={useTxtData.table.SearchTip} source="SearchTip" />
        <TextField label={useTxtData.table.SearchHotKeys} source="SearchHotKeys" />
        <TextField label={useTxtData.table.KeFuTel} source="KeFuTel" />
        <TextField label={useTxtData.table.AdsPics} source="AdsPics" />
        <TextField label={useTxtData.table.AdsUrls} source="AdsUrls" />
        <RowAction />
      </Datagrid>
    </List>
  );
};

////////////////////////////////////////////////////////////////////////
////////////////////////////////////////////////////////////////////////

//SHOW页面
export const WikiShow = (props) => {
  const ShowActions = (props) => {
    const { basePath, data } = props; const redirect = useRedirect();
    return (
      <TopToolbar>
        <Button label="返回列表" onClick={() => redirect(basePath)} variant="text">
          <ArrowBack />
        </Button>
        <EditButton basePath={basePath} record={data} />
      </TopToolbar>
    );
  };

  const classes = useStyles();
  return (
    <Show title={'查看' + useTxtData.page.tableName} {...props} actions={<ShowActions />}>
      <SimpleShowLayout>
        {/* <TextField source="id" /> */}
        {/* <TextField label="名称" source="Name" /> */}
        {/* <TextField label="排序" source="OrderNum" />  */}
        {/* <TextField label={useTxtData.table.WikiID} source="WikiID" /> */}
        <TextField label={useTxtData.table.Title} source="Title" />
        <TextField label={useTxtData.table.OrderTip} source="OrderTip" />
        <TextField label={useTxtData.table.SearchTip} source="SearchTip" />
        <TextField label={useTxtData.table.SearchHotKeys} source="SearchHotKeys" />
        <TextField label={useTxtData.table.KeFuTel} source="KeFuTel" />
        <TextField label={useTxtData.table.AdsPics} source="AdsPics" />
        <TextField label={useTxtData.table.AdsUrls} source="AdsUrls" />
      </SimpleShowLayout>
    </Show>
  );
}

////////////////////////////////////////////////////////////////////////
////////////////////////////////////////////////////////////////////////

//编辑页面
export const WikiEdit = (props) => {
  const PostEditActions = (props) => {
    const { basePath } = props; const redirect = useRedirect();
    return (
      <TopToolbar {...props}>
        <Button label="返回列表" onClick={() => redirect(basePath)} variant="text">
          <ArrowBack />
        </Button>
      </TopToolbar>
    );
  };
  const PostEditToolbar = (props) => {
    return (
      <Toolbar {...props}>
        <SaveButton redirect={false} />
      </Toolbar>
    );
  };
  return (
    <Edit title={'编辑' + useTxtData.page.tableName} undoable={false} {...props} actions={false}>
      <MyForm Edit={true} toolbar={<PostEditToolbar />} />
    </Edit>
  );
};

////////////////////////////////////////////////////////////////////////
////////////////////////////////////////////////////////////////////////

//创建页面
export const WikiCreate = (props) => {
  const PostCreateActions = (props) => {
    const { basePath } = props; const redirect = useRedirect();
    return (
      <TopToolbar {...props}>
        <Button label="返回列表" onClick={() => redirect(basePath)} variant="text" >
          <ArrowBack />
        </Button>
      </TopToolbar>
    );
  };
  const PostCreateToolbar = (props) => {
    const { basePath } = props;
    return (
      <Toolbar {...props}>
        <SaveButton label="保存&列表" redirect={basePath} submitOnEnter={true} />
        <SaveButton label="保存&继续" redirect={false} submitOnEnter={false} variant="text" />
      </Toolbar>
    );
  };

  return (
    <Create title={'新增' + useTxtData.page.tableName} undoable={false} {...props} actions={<PostCreateActions />}>
      <MyForm Create={true} toolbar={<PostCreateToolbar />} />
    </Create>
  );
};

////////////////////////////////////////////////////////////////////////
////////////////////////////////////////////////////////////////////////
//Create和Edit公用表单
const MyForm = (props) => {
  let { Edit, Create } = props;
  return (
    <SimpleForm {...props} >
      {/* <TextInput source="Name" /> */}
      {/* <NumberInput source="OrderNum" /> */}
      {/* <TextInput label={useTxtData.table.id} source="id" validate={[required()]} /> */}
      <TextInput fullWidth label={useTxtData.table.Title} source="Title" validate={[required()]} />
      <TextInput fullWidth label={useTxtData.table.SearchTip} source="SearchTip" validate={[required()]} />
      <TextInput fullWidth label={useTxtData.table.SearchHotKeys} source="SearchHotKeys" validate={[required()]} />
      <TextInput fullWidth label={useTxtData.table.KeFuTel} source="KeFuTel" validate={[required()]} />
      <UpLoadFile multiple label={useTxtData.table.AdsPics} source="AdsPics" validate={[required()]} />
      <TextInput fullWidth label={useTxtData.table.AdsUrls} source="AdsUrls" validate={[required()]} />
      <CustomRichTextInput label={useTxtData.table.OrderTip} source="OrderTip" validate={[]} defaultValue="" />
    </SimpleForm>
  );
}